import SearchCustomer from './modal-search-customer-view'
export default SearchCustomer
